const formatNumberLong = number => {
    return Number(number).toLocaleString('en-GB')
    // let result = ""
    // while (number > 0) {
    //     const rest = number % 1000
    //     result  = result.length > 0 ? `${rest}.${result}` : `${rest}`
    //     number = (number - rest) / 1000
    // }
    // return result || "0"
}

export const formatNumber = (number, long = false) => {
    if (long) return formatNumberLong(number)

    const K = 1000
    const M = K * K
    const G = M * K
    const T = G * K

    // FIX: instead of using toFixed(0) that will round up the number like 19.57 to 20 we will use bitwise operator
    // to truncate with the integer value we have.
    // NOTE: this method will overflow for big numbers (>= signed int32) but for our usage its good!
    //
    // we use floor to rounding down to the integer.
    if (number > T) number = '' + (Math.floor(number / T) | 0) + 'T'
    if (number > G) number = '' + (Math.floor(number / G) | 0) + 'B'
    if (number > M) number = '' + (Math.floor(number / M) | 0) + 'M'
    if (number > 10 * K) number = '' + (Math.floor(number / K) | 0) + 'K'

    return number
}

export const formatCurrency = (number, currency) => {
    let symbol = '$'
    if (currency && currency.toLowerCase() === 'eur') symbol = '€'
    if (currency && currency.toLowerCase() === 'pln') symbol = 'zł'
    if (currency && currency.toLowerCase() === 'gbp') symbol = '£'
    if (currency && currency.toLowerCase() === 'jpy') symbol = '¥'
    return `${symbol} ${number.toFixed(2)}`
}

export function numberWithCommas(x) {
    //console.log('numberWithCommas', x)
    return x && x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function getPercentage(num) {
    let n = parseFloat(num).toFixed(0)
    if (n === 'NaN') return '0'
    return n > 100 ? 100 : n
}

export const formatNumberTwoDigits = number => {
    if (number && !isNaN(number)) {
        return parseFloat(number).toFixed(2)
    }
    return number
}
